export default [{
  path: '/stage/roundCard',
  name: 'stage-roundCard',
  title: '今日轮牌',
  component: () => import('@/views/stage/template/roundCard/index')
}];
